import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { PrimengModule } from './modules/primeng/primeng.module';
import { HomeModule } from './modules/home/home.module';
import { AuthModule } from './modules/auth/auth.module';
import { CommonRequestsModule } from './modules/common-requests/common-requests.module';
import { AdminFunctionsModule } from './modules/admin-functions/admin-functions.module';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        CoreModule,
        HomeModule,
        CommonRequestsModule,
        AdminFunctionsModule,
        AuthModule.forRoot(),
        FormsModule,
        PrimengModule
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
